import styled from "styled-components";

const MOBILE_BREAKPOINT = "768px";

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 16px;
    margin-top: -50px;

    .desktop-only {
        @media (max-width: ${MOBILE_BREAKPOINT}) {
            display: none !important;
        }
    }
`;

export const TopSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const TopRightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
`;

export const CompanyInfo = styled.div`
    display: flex;
    align-items: center;
    font-weight: bold;
    gap: 12px;
    position: relative;
`;

export const BottomSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
    }
`;

export const LeftSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    flex: 1;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
        order: 1;
    }
`;

export const RightSection = styled.div`
    display: flex;
    align-items: center;
    height: ${props => (props.$codOrAccounting ? "150px" : "48px")};
    width: 400px;
    flex-shrink: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        min-width: auto;
        width: 100%;
        justify-content: center;
        order: 2;
    }
`;

export const MenuButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    background-color: ${props => {
        if (props.$isActive) return "#AEF001";
        if (props.$isLogout) return "#fff";
        return "#fff";
    }};
    color: ${props => {
        if (props.$isActive) return "#000";
        if (props.$isLogout) return "#ff4d4f";
        return "#333";
    }};
    font-size: 14px;
    font-weight: ${props => (props.$isActive ? "600" : "500")};
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid ${props => (props.$isActive ? "#AEF001" : "#f0f0f0")};

    &:hover {
        background-color: ${props => {
            if (props.$isActive) return "#AEF001";
            if (props.$isLogout) return "#ffe7e7";
            return "#f8f8f8";
        }};
        transform: translateY(-2px);
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        justify-content: flex-start;
    }

    ${props =>
        props.$isMobile &&
        `
        width: 100%;
        justify-content: flex-start;
        margin-bottom: 8px;
    `}
`;

export const ButtonIcon = styled.img`
    width: 16px;
    height: 16px;
`;

export const MobileMenuToggle = styled.button`
    display: none;
    flex-direction: column;
    justify-content: space-around;
    width: 30px;
    height: 30px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        display: flex;
    }

    span {
        width: 25px;
        height: 3px;
        background: #333;
        border-radius: 10px;
        transition: all 0.3s linear;
        position: relative;
        transform-origin: 1px;

        ${props =>
            props.$isOpen &&
            `
            &:first-child {
                transform: rotate(45deg);
            }

            &:nth-child(2) {
                opacity: 0;
                transform: translateX(20px);
            }

            &:nth-child(3) {
                transform: rotate(-45deg);
            }
        `}
    }
`;

export const MobileMenu = styled.div`
    display: none;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        display: ${props => (props.$isOpen ? "block" : "none")};
        position: absolute;
        top: 80px;
        right: 0;
        background: white;
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        padding: 16px;
        z-index: 1000;
        border: 1px solid #f0f0f0;
        min-width: 200px;
    }
`;

export const MobileAccountSection = styled.div`
    ${MenuButton} {
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;
